<template>
  <div>
    <div class="xl:grid grid-cols-appPage gap-twentyFive">
      <div>
        <div class="g-page__header">
          <h2 data-hj-suppress>{{ contactHasLoaded ? contact.title : $t('functional.loading') }}</h2>
          <span data-hj-suppress>
            {{ contactHasLoaded ? contact.email : $t('functional.loading') }}
          </span>
        </div>
        <VTabs
          @showing="handleShowingTab"
          class="mb-twentyFive"
        >
          <div
            v-for="tab in tabs"
            :key="tab.slot"
            :slot="tab.slot"
            :title="tab.title"
            :icon="tab.icon"
          >
            <EnvelopeOverviewCard
              v-for="(envelope, index) in envelopeCardArray"
              :key="index"
              :loading="isLoading"
              :envelope="envelope"
              ec="Contacts"
              @cancel="openCancelEnvelopeModal(envelope)"
              @remove="openRemoveEnvelopeModal(envelope)"
              @openReminder="openRemindersSetModal(envelope)"
              @openResendNowModal="openResendNowModal(envelope)"
            />
            <NoEnvelopesForContactEmptyState
              v-if="!results.length && !isLoading"
              key="no-envelopes"
            />
          </div>
        </VTabs>
      </div>
      <div>
        <div class="g-sidebar__container">
          <h3 class="g-sidebar__container__header">
            <InfoCircleIcon
              height="22"
              width="22"
            />
            <span>{{ $t('functional.whatIsThis') }}</span>
          </h3>
          <p>{{ $t('contactStatus.whatIsThisMessage') }}</p>
        </div>
        <HelpAndSupportWidget />
      </div>
    </div>
    <EnvelopeCancelModal
      :show="showEnvelopeCancelModal"
      :envelope="selectedEnvelope"
      @close="showEnvelopeCancelModal = false;"
      @envelopeCancelled="markEnvelopeCancelled(selectedEnvelope.fingerprint)"
    />
    <EnvelopeDeleteModal
      :show="showEnvelopeDeleteModal"
      :envelope="selectedEnvelope"
      @close="showEnvelopeDeleteModal = false;"
      @envelopeDeleted="markEnvelopeDeleted(selectedEnvelope.fingerprint)"
    />
    <EnvelopeResendNowModal
      :envelope="selectedEnvelope"
      :show="showEnvelopeResendModal"
      @close="showEnvelopeResendModal = false"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { useEnvelopesList } from '@/composables/envelopes';
import VTabs from '@/components/deprecated/molecules/Tabs.vue';
import NoEnvelopesForContactEmptyState from '@/components/ui/contacts/NoEnvelopesForContactEmptyState.vue';
import EnvelopeOverviewCard from '@/components/ui/envelopes/EnvelopeOverviewCard.vue';

import HelpAndSupportWidget from '@/views/components/HelpAndSupportWidget.vue';
import EnvelopeCancelModal from '@/views/modals/envelope/EnvelopeCancelModal.vue';
import EnvelopeDeleteModal from '@/views/modals/envelope/EnvelopeDeleteModal.vue';
import EnvelopeResendNowModal from '@/views/modals/envelope/EnvelopeResendNowModal.vue';
import { InfoCircleIcon } from '@/components/icons/fontIcons';

export default {
  name: 'ContactStatus',
  inject: {
    $validator: '$validator',
  },
  components: {
    NoEnvelopesForContactEmptyState,
    EnvelopeOverviewCard,
    VTabs,
    HelpAndSupportWidget,
    EnvelopeCancelModal,
    EnvelopeDeleteModal,
    EnvelopeResendNowModal,
    InfoCircleIcon,
  },
  computed: {
    ...mapGetters({
      contact: 'contacts/contact',
    }),
    envelopeCardArray() {
      if (this.isLoading) {
        return new Array(4).fill({});
      }
      return this.results;
    },
  },
  data() {
    return {
      contactHasLoaded: false,
      selectedEnvelope: {},
      showEnvelopeCancelModal: false,
      showEnvelopeResendModal: false,
      showEnvelopeDeleteModal: false,
      tabs: [
        {
          slot: 'sent',
          title: 'In Progress',
          icon: 'paper-plane',
        },
        {
          slot: 'signed',
          title: 'Signed',
          icon: 'pencil-square',
        },
        {
          slot: 'draft',
          title: 'Draft',
          icon: 'file',
        },
        {
          slot: 'cancelled',
          title: 'Cancelled',
          icon: 'ban',
        },
        {
          slot: 'rejected',
          title: 'Rejected',
          icon: 'times',
        },
        {
          slot: 'verify',
          title: 'Unverified',
          icon: 'magnifying-glass',
        },
        {
          slot: 'expired',
          title: 'Expired',
          icon: 'clock',
        },
      ],
    };
  },
  setup() {
    const {
      fetch,
      results,
      meta,
      isLoading,
      markEnvelopeDeleted,
      markEnvelopeCancelled,
    } = useEnvelopesList();

    return {
      fetch,
      results,
      meta,
      isLoading,
      markEnvelopeDeleted,
      markEnvelopeCancelled,
    };
  },
  created() {
    this.$store.dispatch('contacts/GET', {
        id: this.$route.params.contactId,
    }).finally(() => {
      this.contactHasLoaded = true;
    });

    this.loadEnvelopes('sent');
  },
  methods: {
    handleShowingTab(tab) {
      this.loadEnvelopes(tab);
    },
    loadEnvelopes(status) {
      this.fetch({
        contact_id: { inc: [this.$route.params.contactId] },
        status: { inc: [status] },
      });
    },
    openRemindersSetModal(envelope) {
      this.selectedEnvelope = envelope;
      this.$bus.$emit('toggleModal', { name: 'reminders-set-modal', active: true });
    },
    openResendNowModal(envelope) {
      this.selectedEnvelope = envelope;
      this.showEnvelopeResendModal = true;
    },
    openCancelEnvelopeModal(envelope) {
      this.selectedEnvelope = envelope;
      this.showEnvelopeCancelModal = true;
    },
    openRemoveEnvelopeModal(envelope) {
      this.selectedEnvelope = envelope;
      this.showEnvelopeDeleteModal = true;
    },
  },
};
</script>

<style scoped>
.p-contacts__controls {
  display: flex;
}
</style>
